import { Container } from "@components/ui/Container";
import { Products as ProductsSection, Cta } from "@components/sections";
import { products, productCategories } from "@data/products";
import styles from "./Products.module.css";

export default function ProductsPage() {
  const popularCount = products.filter((p) => p.popular).length;

  return (
    <>
      <section className={styles.hero}>
        <Container>
          <div className={styles.heroInner}>
            <span className={styles.eyebrow}>Productos</span>
            <h1 className={styles.title}>
              Coberturas para personas, familias y empresas
            </h1>
            <p className={styles.lead}>
              Conocé todas las opciones que trabajamos. Filtrá por tipo o categoría y
              cotizá la que se ajuste a tu perfil.
            </p>

            <div className={styles.statsRow}>
              <div className={styles.stat}>
                <span className={styles.statValue}>{products.length}</span>
                <span className={styles.statLabel}>Productos</span>
              </div>
              <div className={styles.stat}>
                <span className={styles.statValue}>{productCategories.length}</span>
                <span className={styles.statLabel}>Categorías</span>
              </div>
              <div className={styles.stat}>
                <span className={styles.statValue}>{popularCount}</span>
                <span className={styles.statLabel}>Más solicitados</span>
              </div>
            </div>
          </div>
        </Container>
      </section>

      <ProductsSection />

      <Cta
        title="¿No sabés qué cobertura te conviene?"
        body="Te asesoramos sin compromiso. En 24hs te enviamos una propuesta a medida."
      />
    </>
  );
}
